import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";
import PropertyCard from "@/components/locanest/PropertyCard";

export default function ExploreNearby({ propertyId, city }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/properties/${propertyId}/nearby`, { params: { limit: 8 } }).then(({ data }) => setData(data)).catch(() => setData({ items: [] }));
  }, [propertyId]);

  if (!data || data.items.length === 0) return null;

  return (
    <section className="mt-14" data-testid="explore-nearby">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#C85A32]">Explore Nearby</div>
          <h2 className="font-display text-2xl md:text-3xl mt-1">Nearby rentals in {city}</h2>
          <p className="text-sm text-[#5C6B7A] mt-1">Real listings close to this location, nearest first.</p>
        </div>
        <Link to={`/listings?city=${encodeURIComponent(city)}`} className="text-sm text-[#C85A32] font-medium inline-flex items-center gap-1 shrink-0 hover:underline" data-testid="nearby-see-all">
          See all <ChevronRight size={14} />
        </Link>
      </div>
      <div className="mt-5 flex gap-4 overflow-x-auto pb-3 -mx-5 px-5 md:mx-0 md:px-0 snap-x" data-testid="nearby-list">
        {data.items.map((p) => (
          <div key={p.id} className="relative w-[270px] shrink-0 snap-start" data-testid={`nearby-card-${p.id}`}>
            <PropertyCard p={p} />
            <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-[#1A1F2C]/75 text-white text-[10px] tabular-nums" data-testid={`nearby-distance-${p.id}`}>
              {p.distance_km < 1 ? "< 1 km" : `${p.distance_km} km`}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
